/** Élèves / Familles list pages (VIS1 PageFrame headers). */
export const PEOPLE_COPY = Object.freeze({
  studentsTitle: 'Élèves',
  familiesTitle: 'Familles',
  studentsCount: (n) => `${n} élève${n !== 1 ? 's' : ''}`,
  familiesCount: (n) => `${n} famille${n !== 1 ? 's' : ''}`,
});

/** RecordAvatar: initials that open the student / family fiche. */
export const RECORD_AVATAR_COPY = Object.freeze({
  open: (name) => `Ouvrir la fiche de ${name}`,
  notFound: 'Fiche introuvable : elle a peut-être été archivée ou supprimée.',
});

/** Family school zone: computed by the backend from the postal code; the teacher may override it. */
export const SCHOOL_ZONES = Object.freeze(['A', 'B', 'C']);
export const FAMILY_ZONE_COPY = Object.freeze({
  label: 'Zone scolaire',
  hint: 'Sert aux vacances scolaires (séances sautées, statistiques).',
  automatic: (zone) => (zone ? `Automatique · zone ${zone}` : 'Automatique (d’après le code postal)'),
  zone: (zone) => `Zone ${zone}`,
  value: (zone) => (zone ? `Zone ${zone}` : '—'),
});
